export const locale = {
    lang: 'zh',
    data: {
        MENU: {
            ACTIONS: '行动',
            CREATE_POST: '创建新帖子',
            PAGES: '网页',
            FEATURES: '特征',
            DASHBOARD: '仪表板',
            PROJECTS: '項目表',
            RECENT_PROJECTS: '最近的项目',
            DIRECT_CHAT: '直接聊天',
            LATEST_UPDATES: '最新更新',
            HOME: '首页',
            CHAT_GROUPS: '聊天群组',
            FILES: '文档',
            SCHEDULE: '日程表',
            GANTT_CHART: '日程表',
            PROJECT_SETTINGS: '项目设定',
            SPACE_MANAGEMENT: '空间设定',
            TEAM_MANAGEMENT: '团队设定',
            SYSTEM_MANAGEMENT: '系统设定',
            SPACE_SETTINGS: '修改空间设置',
            TEAM_SETTINGS: '修改团队设置',
            LANGUAGE_AND_TIME_SETTINGS: '语言和时间设置',
            USERS: '用户数',
            SPACES: '顾客表',
            TEAMS: '团队表',
            JAPAN_TEAM: 'Japan Teams',
            JAPAN_TEAM_LIST: 'Japan Team List',
            OVERSEAS_TEAM: 'Overseas Teams',
            OVERSEAS_TEAM_LIST: 'Overseas Team List',
            MY_SETTINGS: '我的设置',
            USER_INFO: '用户信息',
            EMAIL: '电子邮件',
            PASSWORD: '密码',
            ORDER: '下订单',
            TEAM_ORDER: '新项目',
            PRIVACY_POLICY: '私隐权声明',
            TERMS_OF_SERVICE: '使用条款',
            COMPANY: 'OrderGo！东京 STUDIO55，Inc.保留所有权利。',
            SEARCH_RESULTS: '搜索结果列表',
            CLIENT: '顾客',
            CUSTOMER: '顾客',
            READ_ALL: 'READ ALL',
            SEARCH_LATEST_CHANGES: "Search latest changes..."
        },
        AUTH: {
            GENERAL: {
                OR: '或者',
                SUBMIT_BUTTON: '提交',
                NO_ACCOUNT: '没有账号？',
                SIGNUP_BUTTON: '注册',
                FORGOT_BUTTON: '忘记密码?',
                SAVE_BUTTON: '保存密码',
                BACK_BUTTON: '返回',
                PRIVACY: '隐私',
                LEGAL: '法律',
                CONTACT: '联系',
                LOGOUT: '退出',
                SAVE_NOTIFICATION: '用户已保存'
            },
            LOGIN: {
                TITLE: '登录',
                BUTTON: '登录账号',
            },
            FORGOT: {
                TITLE: '忘记密码?',
                DESC: '输入您的电子邮件以重置您的密码',
                SUCCESS: '您的帐户已成功重置。'
            },
            REGISTER: {
                TITLE: '注册',
                DESC: '输入您的详细信息以创建您的帐户',
                SUCCESS: '您的帐户已成功注册。'
            },
            INPUT: {
                EMAIL: '电子邮件',
                FULLNAME: '全名',
                PASSWORD: '密码',
                CONFIRM_PASSWORD: '确认密码',
                USERNAME: '用戶名'
            },
            VALIDATION: {
                INVALID: '{{name}} 无效',
                REQUIRED: '{{name}} 必需填写',
                MIN_LENGTH: '{{name}} 最多可输入的文字数为 {{min}}',
                AGREEMENT_REQUIRED: '需要接受条款和条件',
                NOT_FOUND: '查找不到请求的 {{name}}',
                INVALID_LOGIN: '登录的详细信息不正确',
                REQUIRED_FIELD: '必填项目',
                MIN_LENGTH_FIELD: '最长字段长度：',
                MAX_LENGTH_FIELD: '最短字段长度：',
                INVALID_FIELD: '数值无效',
            }
        },
        PROJECTS: {
            PROJECTS_LIST: '项目表',
            PROJECT_HOME: '项目首页',
            LATEST_CHANGES: '最新更新',
            CHAT_GROUPS: '聊天群组',
            FILES: '文档',
            SCHEDULE: '日程表',
            GANTT_CHART: '日程表',
            SETTINGS: '项目设定',
            DELETE_USER: '删除用户',
            EDIT_FILE: '编辑文件',
            DELETE_FILE: '删除文件',
            DELETE_PROJECT: {
                TITLE: '删除项目',
                DESCRIPTION: '您确定要删除此项目吗？',
                WAIT_DESCRIPTION: '正在删除此项目...',
                MESSAGE: '项目已删除。'
            },
            RESTORE_PROJECT: {
                TITLE: '恢复项目',
                DESCRIPTION: '您确定要恢复此项目吗？',
                WAIT_DESCRIPTION: '正在恢复此项目...',
                MESSAGE: '项目已恢复。'
            },
            DELETE_MULTIPLE_PROJECTS: {
                TITLE: '标题',
                DESCRIPTION: '描述',
                WAIT_DESCRIPTION: '等待说明',
                MESSAGE: '信息'
            },
            ADD_SCHEDULE_BUTTON: '添加日程',
            EXPORT_TO_PDF: '导出PDF',
            EXPORT_TO_PDF_MOBILE: 'PDF',
            SAVE: '保存到',
            CANCEL: '取消',
            CLOSE: 'Close',
            DONE : '已完成',
            PERMISSION : '允许',
            RESET: '从新设置',
            INFO: '项目信息',
            NAME: '项目名称',
            START_DATE: 'Start Date',
            SCHEDULED_DELIVERY_DATES: '予定纳品日期',
            DELIVERY_DATES: '纳品日期',
            SUB: '辅助类型选择',
            SUB_TYPE: 'Sub Type',
            SUB_TYPE_CAMERA: 'Camera Angle',
            SUB_TYPE_SOFTWARE: 'Software',
            SUB_TYPE_ANIMATION: 'Production Seconds',
            USER: '用户',
            ADD_USER: '添加用户',
            PROJECT_NAME_ERROR : 'Name does not match.',
            PROJECT_NAME_REQUIRED : 'Project Name Required',
            PROJECT_SEARCH : {
                PROJECT_NAME : '项目名',
                FROM_DELIVERY_DATE : '从预计纳品日期',
                TO_DELIVERY_DATE : '到预计纳品日期',
                FROM_CREATION_DATE : '从创建日期开始',
                TO_CREATION_DATE : '到创建日期',
                APPLY_FILTERS: '保存设置',
                SORT_CATEGORY : '排序类别',
                SORT_TYPE : '排序类型',
            },
            SCHEDULED_DATE_OF_DELIVERY: 'Scheduled date of delivery',
            DATE_OF_DELIVERY: 'Date Of Delivery',
            CREATED_BY: 'Created By',
            PRICE: 'Price',
            MODIFIED_AT: 'Modified At',
            MENU: 'Menu',
            COMMENT_ON_DELIVERY: 'Comment',
            ADDITIONAL_URLS: 'Additional URLs',
            BACK_TO_CHAT_ROOM: 'Back to the chat room',
        },
        PROJECT_MANAGEMENT: {
            ATTACHED_FILES: '附件',
            MESSAGE_PLACEHOLDER: '请输入您的信息...'
        },
        ZOOM: {
            MEETING: 'ZOOM会议',
            START_MEETING: 'ZOOM会议开始',
            TOPIC: '会议名称',
            CANCEL: '取消',
            CREATE: '创造',
            WAITING: 'ZOOM会议尚未开始。你想开始？',
            STARTED: 'ZOOM会议正在举行。您确定要参加吗？',
            ENDED: 'ZOOM会议已经结束。',
            TOPIC_REQUIRED: '会议名称为必填项。',
        },
        GENERAL: {
            FORM_ERROR: '输入中有错误。请在确认后再次发送。',
            DUPLICATE_USER_ERROR: 'The provided email is already registered. Please use a different email or use the password restore service.',
            DUPLICATE_EMAIL_ERROR: 'The provided email is already registered. Please use a different email.',
            SEARCH: '查找',
            SELECTED_RECORDS_COUNT: '已选',
            CUSTOMER_SUFFIX: '',
            CALENDAR_DAY_0: 'SUN',
            CALENDAR_DAY_1: 'MON',
            CALENDAR_DAY_2: 'TUE',
            CALENDAR_DAY_3: 'WED',
            CALENDAR_DAY_4: 'THU',
            CALENDAR_DAY_5: 'FRI',
            CALENDAR_DAY_6: 'SAT',
        },
        SCHEDULES: {
            EDIT_SCHEDULE: {
                UPDATE_MESSAGE: 'Task Edited Successfully.',
                ADD_MESSAGE: 'Task Added Successfully.'
            }
        },
        CONVERSATIONS: {
            ADD_BUTTON: '添加聊天组',
            USER_NAME: '用户名',
            CONVERSATIONS_LIST: '聊天组列表',
            CONVERSATIONS_HOME: '',
            SUBJECT: '件名',
            SUBJECT_ERROR: '会话主题为必填项',
            ACTIONS: '动作',
            VIEW_CONVERSATION: '',
            EDIT_CONVERSATION: {
                TITLE: '聊天组编辑',
                UPDATE_MESSAGE: '聊天组编辑',
                ADD_MESSAGE: '聊天组追加'
            },
            DELETE_CONVERSATION: {
                TITLE: '删除聊天组',
                DESCRIPTION: 'DELETE_CONVERSATION.DESCRIPTION',
                WAIT_DESCRIPTION: 'DELETE_CONVERSATION.WAIT_DESCRIPTION',
                MESSAGE: 'DELETE_CONVERSATION.MESSAGE'
            },
            DELETE_PRIVATE_CONVERSATION: {
                TITLE: 'Delete private chat group',
                DESCRIPTION: 'Are you sure you want to delete this private chat?',
                WAIT_DESCRIPTION: 'Deleting the private chat...',
                MESSAGE: 'private chat was deleted'
            },
            MEMBERS: '群组名单',
            PRIVATE_CHAT: 'Private chat',
            PRIVATE_CHAT_REGISTERED: '(Registered)',
            ADD_USER: '追加使用者',
            FILE_NAME: '档案名称',
            NO_DATA_DESCRIPTION: '查找不到资料',
            NEW_ANNOTATION: '新注释已添加到文件',
            SYSTEM_MESSAGE: 'System Message',
            CHECK_ESTIMATE_TITLE: 'please check estimate',
            CHECK_ESTIMATE_DESCRIPTION: 'Is the above estimated amount all right?',
            CHECK_ESTIMATE_PENDING: 'Estimate under confirmation',
            CHECK_ESTIMATE_ACCEPT: 'YES',
            CHECK_ESTIMATE_ACCEPTED: 'We received an agreement on the estimated amount.',
            CHECK_ESTIMATE_REJECT: 'NO',
            CHECK_ESTIMATE_REJECTED: 'We will consider the contents of the quotation again.',
            FINAL_VERSION_DESCRIPTION: '※The project will be completed when the delivery is OK.<br />※Select NO for correction.',
            FINAL_VERSION_ACCEPT_MESSAGE: 'Delivery is complete.',
            FINAL_VERSION_REJECT_MESSAGE: 'Delivery is incomplete.',
            CHECK_SCHEDULE: 'Check Schedule',
            FULL_SIZE_IMAGE_DOWNLOAD: 'Download full size image',
            FINAL_VERSION_TITLE: 'Final Version',
            FINAL_VERSION_PENDING: 'Pending for confirmation',
            FINAL_VERSION_ACCEPT: 'Accept as Final Version',
            FINAL_VERSION_ACCEPTED: 'Accepted as Final Version',
            FINAL_VERSION_REJECT: 'Reject as Final Version',
            FINAL_VERSION_REJECTED: 'Rejected as Final Version',
            WITHOUT_AUTOMATIC_TRANSLATIONS: 'Automatic translations (disabled)',
            WITH_AUTOMATIC_TRANSLATIONS: 'Automatic translations (enabled)',
            CONVERSATION_NAME: 'Chat Group',
            CREATED_AT: 'Created At',
            FILE_UPLOAD: 'File Upload',
            LIBRARY: 'Library',
            CROP_TOOL: 'Crop Tool',
            EMOJI: 'Emoji',
            AI_GENERATE: "AI Generate",
            ZOOM: 'Zoom',
            AUTO_SCROLL_IS_DISABLED: 'Auto scrolling is disabled',
            SYSTEM_MESSAGE_CREATE_PROJECT: '<p>From ORDER GO!</p><p>Thank you for joining for ORDER GO!</p><p>The person in charge will contact you via this chat today, so please be patient.</p><p>If we contact you via this chat, you will also be alerted to your ORDER GO! Registration email.</p><p class="kt-chat__description">The order reception time is from 11:00 AM to 8:00 PM.<br />Please note that we will contact you today during the order reception time.<br />If it is outside the order reception time, we will contact you tomorrow.</p>',
            SYSTEM_MESSAGE_CONFIRM_ESTIMATE: '<p>Thank you for your order.</p><p>The director in charge of production will contact you via this chat, so please be patient.</p><p class="kt-chat__description">※If we contact you via this chat, you will also be alerted to your ORDER GO! Registration email.</p>',
            SYSTEM_MESSAGE_REJECT_ESTIMATE: '<p>Please wait for a while as the sales representative will contact you again.</p><p>If we contact you via this chat, you will also be alerted to your ORDER GO! Registration email.</p><p class="kt-chat__description">※Business hours AM11: 00 ~ PM8: 00<br />※Please note that we will contact you tomorrow if it is outside business hours.</p>',
            SYSTEM_MESSAGE_CONFIRM_FINAL_VERSION: '<p>Thank you for confirming delivery.</p><p>This case is completed here.</p><p>Thank you for your order.</p><p class="kt-chat__description">※Please let us know if there is a correction again.</p>',
            SYSTEM_MESSAGE_REJECT_FINAL_VERSION: '<p>Thank you for your confirmation.</p><p>Please check back on the image again and the director in charge of production will contact you on this chat so please wait for a while.</p>',
            SYSTEM_MESSAGE_SEND_SCHEDULE: '<p>Please check that we have entered the production schedule.</p><p class="kt-chat__description">※Please let us know if there is any inconvenience in the checkback schedule.</p>',
            SYSTEM_MESSAGE_ADD_ANNOTATION: '<p>Thank you for checking back.</p><p>We will proceed with the production here.</p><p class="kt-chat__description">Depending on the content of the correction, the director in charge of production may ask you a question.</p>',
        },
        MESSAGES: {
            SAVE_ANGLE: '保存角度',
            ADD_ANGLE: 'Add Angle',
            RESTORE_ANGLE: 'Restore Angle',
            DELETE_ANGLE: 'Delete Angle',
            DESCRIPTION_ANGLE_TOOL: 'Click the save button when you find an angle that interests you and comment.',
            DELETE_MESSAGE: {
                TITLE: '删除此对话',
                DESCRIPTION: '说明',
                WAIT_DESCRIPTION: '等待说明',
                MESSAGE: '对话'
            },
            IMAGE_TOOL: 'Image Review Tool',
            DESCRIPTION_IMAGE_TOOL: 'Use the image annotation tools below to highlight or comment on what interests you.',
            ANGLE_REVIEW_TOOL: 'Angle Review Tool'
        },
        MY_SETTINGS: {
            MY_SETTINGS: '个人设定',
            USER_INFO: '用户信息',
            EMAIL: '邮件',
            PASSWORD: '密码',
            SAVE_PASSWORD : 'Change Password',
            SAVE: '保存到',
            RESET: '重设',
            CREATE_USER: '创建用户',
            EDIT_USER: '编辑用户',
            USER_DETAIL: {
                EMAIL: '电邮地址',
                USER_NAME: '用户名',
                ICON: '图标',
                BACKGROUND_PIC: '背景图片',
                SELECT_IMAGE: '选择图片',
                LANGUAGE: '语言',
                TIMEZONE: '时区',
                USER_GROUP: '用户群组',
                USER_GROUP_NAME: '用户群组名',
                USER_GROUP_NAME_REQUIRED: '用户群组名 Required',
                SELECT_USER_GROUP: '用户群组選択',
                ROLE: '权限',
                STANDARD_IMAGE: '标准图标',
                STANDARD_IMAGE_DESCRIPTOPN: '选择图标',
                OPEN_BACKGROUND_IMAGE_SELECTION_SCREEN: 'Open background selection screen',
                ORIGINAL_IMAGE: '自定义图标',
                ORIGINAL_IMAGE_DESCRIPTOPN: '选择档案',
                IMAGE_DESCRIPTION: '如果自定义图标的尺寸超过100x100，则会自动缩小',
                LANGUAGE_DESCRIPTION: '如果用户设置过个人设置，则会优先个人设置。',
                TIMEZONE_DESCRIPTION: '分配到期时间的判断将基于时区。',
            },
            EMAIL_DETAIL: {
                EMAIL: '电邮地址：',
                RECIEVE_EMAIL: '接收邮件',
                RECIEVE_MYREPORT: '接收我的报告',
                RECIEVE_SETTINGS: '电子邮件主题中不要包含“新建”，“评论”，“完成”，“更改联系人”',
                RECIEVE_SETTINGS_DESCRIPTION: '（如果您使用Gmail，则有关同一问题的电子邮件将显示在一个主题中。）',
                PROJECT: '关于项目的电子邮件：',
                ISSUE: '议题',
                RECEPTION_TIMING: '接收的时间',
                LIMIT_ISSUE: '限制接收议题',
                NOTIFICATION: '注意事项',
                PROJECT_REPORT: '项目报告',
                ADD: '添加或更新时',
                COMMENT: '添加评论时',
                All: '接收所有议题',
                CHARGE: '自己负责',
                REGISTERED: '自己注册',
                ALWAYS_RECEIVE: '一律接收发给自己的通知',
                RECEIVE_PROJECT_REPORT: '接收项目报告',
                GENERAL_SETTING: '基本设定',
                GENERAL_SETTING_DESCRIPTION: '基本设置（此设置用于没有单独设置的项目。）'
            },
            DELETE_USER_MODAL: {
                TITLE : '删除用户',
                DESCRIPTION : '您确定要永久删除该用户吗？',
                WAIT_DESCRIPTION : '删除用户...',
                DELETE_MESSAGE : '用户已删除'
            },
            DELETE_TEAM_MODAL: {
                TITLE : '删除团队',
                DESCRIPTION : '您确定要永久删除该团队吗？',
                WAIT_DESCRIPTION : '正在删除团队...',
                DELETE_MESSAGE : '团队已删除。'
            },
            DELETE_SPACE_MODAL: {
                TITLE : '删除空间',
                DESCRIPTION : '您确定要永久删除该空间吗？',
                WAIT_DESCRIPTION : '删除空间...',
                DELETE_MESSAGE : '空间已删除。'
            },
            DELETE_SUUMO_SPACE_MODAL: {
                TITLE: 'Delete SUUMO Space(s)',
                DESCRIPTION: 'Are you sure you want to permanently delete SUMMO Space(s)?',
                WAIT_DESCRIPTION: 'Deleting SUUMO Space(s)...',
                DELETE_MESSAGE: 'SUUMO Space(s) Deleted.'
            },
            DELETE_USER_GROUP_MODAL: {
                TITLE: 'Delete User Group(s)',
                DESCRIPTION: 'Are you sure you want to permanently delete User Group(s)?',
                WAIT_DESCRIPTION: 'Deleting User Group(s)...',
                DELETE_MESSAGE: 'User Group(s)... Deleted'
            },
            PASSWORD_DETAIL: {
                EMAIL: '电邮地址',
                USER_NAME: '用户名',
                PASSWORD: '密码',
                CURRENT_PASSWORD: '当前密码',
                NEW_PASSWORD : '新密码',
                CONFIRM_PASSWORD: '确认密码'
            },
            VALIDATION_ERROR_MESSAGE: 'Please fill out the following field(s): {{fields}}'
        },
        SPACE_MANAGEMENT: {
            SPACE_SETTINGS: '空间设定',
            CUSTOMER_SETTINGS: '客户设定',
            SPACE_INFO: '编辑空间',
            CUSTOMER_INFO: 'Customer info',
            LANGUAGE_AND_TIME_SETTINGS: '语言和时间设置',
            USERS: '用户',
            PROJECTS: '项目列表',
            SAVE: '保存到',
            RESET: '重设',
            BACK: '返回',
            REQUEST_ADD_USER: 'Request',
            ACTIONS: '动作',
            EDIT_USER: '修改用户',
            DELETE_USER: '删除用户',
            EDIT_PROJECT: '编辑项目',
            DELETE_PROJECT: '删除项目',
            GENERAL_INFORMATION: '一般信息',
            PASSWORD: '密码',
            SETTINGS_DETAIL: {
                SPACE_NAME: '空间名:',
                SPACE_PLACEHOLDER: '空间名',
                EDIT_SPACE: '编辑空间',
                ADMINISTRATOR: 'STUDIO55 营业担当者',
                CUSTOMER_NAME: 'Customer Name'
            },
            LANGUAGE_AND_TIME_SETTINGS_DETAIL: {
                LANGUAGE_AND_TIME_SETTINGS: '语言和时间设置',
                LANGUAGE: '语言',
                LANGUAGE_DESCRIPTION: '如果用户设置过个人设置，则会优先个人设置。',
                TIMEZONE: '时区',
                TIMEZONE_DESCRIPTION: '议题的期限基于这个时间来判断',
            },
            USERS_DETAIL: {
                ADD: '新增使用者',
                USERNAME: '用户名',
                EMAIL: '电子邮件',
                AUTHORITY : '权限',
                COMPANY_NAME : '公司名',
            },
            ADD_SPACE_BUTTON_TEXT : '增加空间',
            RESET_SPACE_BUTTON_TEXT : '重置',
            SAVE_SPACE_BUTTON_TEXT : '保存',
            LIST_OF_SPACE : '顾客列表',
            LIST_OF_CUSTOMER : '客户名单',
            LIST_OF_USER_GROUP: '用户群组列表',
        },
        TEAM_MANAGEMENT: {
            TEAM_SETTINGS: '团队设定',
            TEAM_INFO: '编辑团队',
            TEAM_NAME: '团队名称',
            LANGUAGE_AND_TIME_SETTINGS: '语言和时间设置',
            SAVE: '保存',
            RESET: '重置',
            BACK: '返回',
            ACTIONS: '动作',
            EDIT_USER: '修改用户',
            DELETE_USER: '删除用户',
            EDIT_TEAM : '编辑团队',
            USERS: '用户列表',
            PROJECTS: '项目列表',
            EDIT_PROJECT: '编辑项目',
            DELETE_PROJECT: '删除项目',
            GENERAL_INFORMATION: '一般信息',
            PASSWORD: '密码',
            SETTINGS_DETAIL: {
                TEAM_NAME: '团队的名称',
                TEAM_PLACEHOLDER: '团队的名称',
                TEAM_TYPE: '团队类型'
            },
            LANGUAGE_AND_TIME_SETTINGS_DETAIL: {
                LANGUAGE_AND_TIME_SETTINGS: '语言和时间设置',
                LANGUAGE: '语言',
                LANGUAGE_DESCRIPTION: '如果用户设置过个人设置，则会优先个人设置。',
                TIMEZONE: '时区',
                TIMEZONE_DESCRIPTION: '议题的期限基于这个时间来判断',
            },
            USERS_DETAIL: {
                ADD: '添加用户',
                USERNAME: '用户名',
                EMAIL: '电子邮件',
                AUTHORITY : '权限'
            },
            ADD_TEAM_BUTTON_TEXT : '添加团队',
            RESET_TEAM_BUTTON_TEXT : '重置',
            SAVE_TEAM_BUTTON_TEXT : '保存',
            LIST_OF_TEAM : '团队列表',
            GANTT_CHART : '日程表'
        },
        SYSTEM_MANAGEMENT: {
            TITLE: '系统管理',
            TEAMS: '团队列表',
            SPACES : '顾客列表',
            SYSTEMS: '顾客列表',
            USERS: '用户列表',
            SYSTEM_SETTINGS: '系统设定',
            SYSTEM_INFO: '编辑顾客',
            USER_GROUP_INFO: '编辑用户群组',
            USER_GROUP_NAME: '用户群组名',
            ADD_USER_GROUP: '添加用户群组',
            USER_GROUP_USERS: 'Affiliated users',
            LANGUAGE_AND_TIME_SETTINGS: '语言和时间设置',
            PROJECTS: '项目列表',
            SAVE: '保存',
            RESET: '重置',
            BACK: '返回',
            ACTIONS: '动作',
            EDIT_USER: '修改用户',
            DELETE_USER: '删除用户',
            EDIT_PROJECT: '编辑项目',
            DELETE_PROJECT: '删除项目',
            RESTORE_PROJECT: '恢复项目',
            GENERAL_INFORMATION: '一般信息',
            PASSWORD: '密码',
            COMPANY_NAME : '公司名',
            CUSTOMER_SPACE : '客户团队',
            TEAM : 'STUDIO 55 团队',
            SETTINGS_DETAIL: {
                SPACE_NAME: '顾客名:',
                SPACE_PLACEHOLDER: '顾客名',
                EDIT_SPACE: '顾客空间',
            },
            LANGUAGE_AND_TIME_SETTINGS_DETAIL: {
                LANGUAGE_AND_TIME_SETTINGS: '语言和时间设置',
                LANGUAGE: '语言',
                LANGUAGE_DESCRIPTION: '如果用户设置过个人设置，则会优先个人设置。',
                TIMEZONE: '时区',
                TIMEZONE_DESCRIPTION: '议题的期限基于这个时间来判断',
            },
            USERS_DETAIL: {
                ADD: '添加用户',
                USERNAME: '用户名',
                EMAIL: '电子邮件',
                AUTHORITY : '权限'
            },
            ADD_SPACE_BUTTON_TEXT : '添加客户',
            RESET_SPACE_BUTTON_TEXT : '重置',
            SAVE_SPACE_BUTTON_TEXT : '保存',
            LIST_OF_SPACE : '顾客列表',
        },
        USER_MANAGEMENT: {
            TITLE: '用户管理',
            TEAMS: '团队列表',
            SPACES: '客户列表',
            USERS: '用户列表',
            ADD_USER_BUTTON_TEXT : '添加用户',
            BACK_USER_BUTTON_TEXT : '返回',
            SAVE_USER_BUTTON_TEXT : '保存',
            LIST_OF_USER : '用户列表',
        },
        NEW_PROJECT_WIZARD: {
            TITLE: '开始订单',
            SELECT_TYPE: '选择类型',
            SUB_TYPE_SELECTION : '选择类型',
            SUB_TYPE_SELECTION_CAMERA: 'Select camera angle',
            SUB_TYPE_SELECTION_SOFTWARE: 'Select software',
            SUB_TYPE_SELECTION_ANIMATION: 'Select production seconds',
            REQUIRED: '*',
            DOCUMENT_UPLOAD: '上传文件',
            SCHEDULED_DELIVERY_DATES: '输入予定纳品日期',
            DELIVERY_DATES: '输入纳品日期',
            COMPLETE: '下订单',
            SELECT_DESCRIPTION: '请从以下类型中选择',
            STATUS: '状态',
            PERTH: 'CG效果图',
            CG: 'CG效果图',
            VR: 'VR・AR・MR',
            BAVR: 'BAVR (Before & After VR)',
            ANIMATION: '动画',
            ANIMATION_TIME: 'Seconds',
            OTHER: 'その他',
            FROM_TIME: '从时间',
            TO_TIME: '到时间',
            BIM: '建模.BIM',
            SKETCHUP: 'SketchUp',
            ENSCAPE: 'Enscape',
            SHAPESPARK: 'Shapespark',
            TWINMOTION: 'Twinmotion',
            FIXED_POINT_PANORAMA: 'Fixed point panorama VR',
            PANORAMA: '全景照片',
            REVIT : 'Revit',
            ARCHI_CAD : 'Archi CAD',
            IF_CG_IS_SELECTED: '<strong> CG效果图 所需资料</strong><ul><li>角度指示</li><li> 平面图</li><li>立面图，剖面图（能够知道高度信息的资料）</li><li> 照明分布图</li><li>外部构成图</li><li>家具灯具等照片</li><li>材质信息（材质照片或厂家产品编号）</li><li>手绘图纸（如果没有图纸的情况下)</li><li>样式规格表（住宅的情况下）</li><li>布置图</li></ul>',
            IF_VR_IS_SELECTED: '<strong> VR 所需资料</strong><ul><li>パノラマ写真(仅适用于BAVR）</li><li> 平面图</li><li> 立面图，剖面图（能够知道高度信息的资料）</li><li> ¥外部结构信息</li><li>照明分布图 </li><li>材质信息</li><li>家具和植物信息 </li><li> 制作范围</li></ul>',
            IF_ANIMATION_IS_SELECTED: '<strong> 动画 所需材料</strong><ul><li> 相机走向指示 </li><li>平面图</li><li>立面图，剖面图（能够知道高度信息的资料）</li><li>照明分布图</li><li>家具，灯具等照片</li><li>材质信息（材质照片或厂家产品编号）</li><li>需制作的时间长度</li></ul>',
            IF_BIM_IS_SELECTED: '<strong> 建模BIM 所需材料</strong><ul><li> 平面图</li><li>立面图，剖面图（能够知道高度信息的资料）</li><li>外部结构信息</li><li>照明分布图</li><li>材质信息</li><li>家具和植物信息</li></ul>',
            COMMENT_ON_DELIVERY: '关于交货的评论',
            SUB_TYPE_SELECTION_DESCRIPTION1: '请从以下辅助类型中选择',
            SUB_TYPE_SELECTION_DESCRIPTION2: '选择辅助项后，自由输入数字或单击“-”和“ +”按钮。',
            PROJECT_NAME: '项目名称',
            TYPE: '种类',
            SOFTWARE: '软件',
            SHORT_TIME: '0分钟〜5分钟',
            MEDIUM_TIME: '5分钟〜10分钟',
            LONG_TIME: '10分钟〜15分钟',
            APPEARANCE: '外观',
            INSIDE_VIEW: '室内',
            AERIAL_VIEW: '鸟瞰',
            COMMENT: '留言',
            DOCUMENT_UPLOAD_DESCRIPTION1: '请拖动文件上传或通过“选择文件”按钮上传文件。',
            DOCUMENT_UPLOAD_DESCRIPTION2: '*请将所有文件放入并压缩至ZIP文件。',
            DOCUMENT_UPLOAD_DESCRIPTION3: '将文件拖放至这里',
            DOCUMENT_UPLOAD_DESCRIPTION4: '或',
            DOCUMENT_UPLOAD_DESCRIPTION5: 'またはファイルのURLを記入してください',
            DOCUMENT_UPLOAD_DESCRIPTION6: '※即使您上传的资料不完整，也可以稍后继续上传。',
            CHOICE_FILE: '选择档案',
            NECESSARY_FILES: '所需材料',
            NECESSARY_FILES_DESCRIPTION: '确保从下面的列表中检查文件夹中的文件。',
            LESS: '以下',
            CAN_UPLOAD: '可以上传的文件',
            CAN_UPLOAD_DESCRIPTION1: '请不要在上传带有密码的文件。如果内容更改或不正确，可以重新上传',
            CAN_UPLOAD_DESCRIPTION2: '“ /：*？” <> |“无法在文件名中使用。 <br>当使用取决于型号的字符时，文件名会除去此文字进行保存',
            PREFERRED_DATE: '希望的纳品日',
            PREFERRED_TIME: '时间段',
            START_DATE: 'Start Date',
            TEN_TO_TWELVE: '10:00 ~ 12:00',
            TWELVE_TO_SIXTEEN: '12:00 ~ 16:00',
            SIXTEEN_TO_NINETEEN: '16:00 ~ 19:00',
            NINETEEN_TO_TWENTYFOUR: '19:00 ~ 24:00',
            TWELVE_TO_SEVENTEEN: '12:00 ~ 17:00',
            SEVENTEEN_TO_TWENTY: '17:00 ~ 20:00',
            ADDITIONAL_DESCRIPTION_WARNING: '納品希望日は弊社営業日（平日のみ）から選択できます。土日の納品を希望の場合は、お手数ですが別途コメント欄にご記入ください。',
            ADDITIONAL_DESCRIPTION: '在以下情况下，费用和纳品日期可能会有所不同。请另外咨询我们。',
            HURRY: '纳品日期紧急没有图纸资料，或者希望从照片和手绘开始制作的情况',
            NIGHT_VIEW: '如果您想选择傍晚或夜景',
            HIGH_QUALITY: '如果您想要高质量',
            COMPLETE_DESCRIPTION1: '订单请求已发送。',
            COMPLETE_DESCRIPTION2: '请等待负责人与您联系。',
            BACK: '返回',
            NEXT: '继续',
            SAVE: '保存到',
            BACK_TO_DASHBOARD: '返回仪表板',
            DATA_SUBMISSION_CONVERSATION: '资料提交',
            DATA_SUBMISSION_MESSAGE: '资料提交',
            TIME: 'Time',
            LOGIN_PERMISSION: 'Login Permission',
            DISABLED: 'Disabled',
            ENABLED: 'Enabled',
            VRARMR: 'VR・AR・MR',
            UNITY: 'Unity',
            UNREAL: 'Unreal',
            IF_SELECTED: 'If the above materials are insufficient, please proceed to the next step.<br />You can upload the material later.',
            IF_NOT_SELECTED: 'There are no required files.',
            DOCUMENT_URL_PLACEHOLDER: 'If you use ファイル便, please enter the URL',
            ADDITIONAL_DESCRIPTION_ABOUT_DAY_AND_TIME: 'Please select the start date, delivery date, and delivery time from the calendar.',
            ADDITIONAL_DESCRIPTION_ABOUT_DAY: 'Please select the desired delivery date from the right.',
            ADDITIONAL_DESCRIPTION_ABOUT_TIME: 'If you have a desired time, please select from the desired delivery time.',
            ADDITIONAL_DESCRIPTION_ABOUT_COMMENT: 'If you have any other comments, please write them in the comments section.',
            COMPLETE_ADDITIONAL_DESCRIPTION1: '※The order has not started at this point.',
            COMPLETE_ADDITIONAL_DESCRIPTION2: '※There is no charge.',
            PROJECT_PROGRESS_GROUP_CONVERSATION: 'Project progress group',
        },
        PRIVACY_POLICY: {
            TITLE: '私隐政策',
            OVERVIEW_DESCRIPTION1: 'STUDIO55，Inc.（以下简称“公司”）密切注意保护通过商业活动获得的客户个人信息，以便客户可以放心使用我们的服务。我们相信保护您的个人信息是我们业务活动和社会责任的基础。为了负责任地保护客户的个人信息，我们建立了公平，适当地管理和操作公司处理的个人信息的规则，并建立了内部系统，实施和维护的措施，并对其进行了持续改进。是的',
            OVERVIEW_DESCRIPTION2: '1.关于处理所有企业处理的个人信息和员工的个人信息等，《个人信息保护法》（2003年第57号法，以下简称“法律”）和其他相关法律法规我们将遵守国家准则和其他标准。',
            OVERVIEW_DESCRIPTION3: '2.如“个人信息的处理”中所述，公司应在获取和使用个人信息时指定使用目的，并将收集超出实现指定使用目的所需范围的个人信息。它将不会被处理（未使用）。此外，我们将采取适当的管理措施以防止未经授权的使用。',
            OVERVIEW_DESCRIPTION4: '3.如“个人信息的处理”中所述，除非获得本人的同意或法律另有要求，否则本公司不会将获取的个人信息提供给第三方。',
            OVERVIEW_DESCRIPTION5: '4.如果我们收到有关处理个人信息的投诉或咨询，我们将及时调查事实等，并在合理的期限内真诚地做出回应。',
            OVERVIEW_DESCRIPTION6: '5.公司应采取组织，人员，物理和技术安全措施，适当管理所获取的个人信息，并努力防止和纠正个人信息的泄漏，丢失或损坏。',
            OVERVIEW_DESCRIPTION7: '6.根据社会状况和环境的变化，公司将继续审查与个人信息保护有关的个人信息保护管理系统，并加大保护个人信息的力度。',
            ESTABLISHMENT: '成立时间：年/月/日',
            COMPANY: 'STUDIO55，Inc.总裁',
            PERSONAL_INFORMATION: '个人信息的处理',
            ARTICLE1: '第一条要获取的个人信息',
            ARTICLE1_DESCRIPTION1: '本公司将依法获取以下个人信息。',
            ARTICLE1_DESCRIPTION2: '（1）与服务登录和使用有关的信息',
            ARTICLE1_DESCRIPTION3: '-服务登录的帐户ID和密码<br>\n' +
                '\t\t\t ・名称，公司名称，电话号码，电子邮件地址作为帐户注册信息<br>\n' +
                '\t\t\t ・您的姓名，公司名称，电话号码，电子邮件地址和其他与客户相关的信息作为与您的帐户<br> \n相关的信息提供 \n' +
                '\t\t\t有关通过使用服务进行的交易的信息以及有关交易内容的信息<br>\n' +
                '\t\t\t ・信用卡信息，银行帐户信息以及有关付款方式的其他信息<br>\n' +
                '\t\t\t ・与客户使用服务发布功能<br> \n提供的发布内容有关的信息，例如图像，文本，注释等\n' +
                '\t\t\t ・有关客户查询和通讯的信息',
            ARTICLE1_DESCRIPTION4: '（2）有关客户使用的设备的信息以及使用cookie等获取的信息。',
            ARTICLE1_DESCRIPTION5: '・有关信息通信终端机标识的信息<br>\n' +
                '\t\t\t ・信息通信终端OS信息<br>\n' +
                '\t\t\t ・有关连接到Internet的信息<br>\n' +
                '\t\t\t ・位置信息<br>\n' +
                '\t\t\t ・推荐人信息<br>\n' +
                '\t\t\t ・ IP地址信息<br>\n' +
                '\t\t\t ・有关URL的时间戳信息以及浏览日期和时间<br>\n' +
                '\t\t\t ・服务使用信息<br>\n' +
                '\t\t\t ・分配给每个客户设备的广告标识符信息<br>\n' +
                '\t\t\t服务器日志信息',
            ARTICLE1_DESCRIPTION6: '（3）与员工等有关的信息',
            ARTICLE1_DESCRIPTION7: '・员工姓名（包括临时员工，兼职），姓名，地址，职业经历以及与员工相关的其他信息<br>\n' +
                '\t\t\t ・与我们的商业伙伴等个人相关的信息',
            ARTICLE1_DESCRIPTION8: '（4）从第三方获得的信息',
            ARTICLE1_DESCRIPTION9: '・经您同意从第三方获得的信息<br>\n' +
                '\t\t\t ・根据法律法规获得的信息<br>\n' +
                '\t\t\t ・通过公开获得的信息',
            ARTICLE2: '第2条个人信息的使用目的',
            ARTICLE2_DESCRIPTION1: '本公司将根据法律在以下目的范围内共同使用第1条所述的个人信息。',
            ARTICLE2_DESCRIPTION2: '（1）服务登录和服务使用',
            ARTICLE2_DESCRIPTION3: '・登录服务<br>\n' +
                '\t\t\t ・提供适合客户的服务<br>\n' +
                '\t\t\t ・为了建立和履行您与我们公司之间的交易以及为客户提供的其他服务，请使用<br>\n' +
                '\t\t\t管理属于该服务成员的客户<br>\n' +
                '\t\t\t用于服务计费<br>\n' +
                '\t\t\t ・有关维修服务必要事项的通知<br>\n' +
                '\t\t\t ・用于各种服务查询和售后服务<br>\n' +
                '\t\t\t ・联系已撤回的客户或回答各种询问<br>\n' +
                '\t\t\t ・预防和应对欺诈',
            ARTICLE2_DESCRIPTION4: '（2）广告/营销',
            ARTICLE2_DESCRIPTION5: '・在第三方媒体上或在第三方媒体上征集，广告或以其他方式推销服务\n' +
                '\t\t\t ・发送电子邮件杂志\n' +
                '\t\t\t ・发送直接邮件\n' +
                '\t\t\t ・用于竞选，抽奖计划和问卷调查',
            ARTICLE2_DESCRIPTION6: '（3）产品研发',
            ARTICLE2_DESCRIPTION7: '・用于营销数据的研究和分析<br>\n' +
                '\t\t\t ・开发我们的新服务和产品',
            ARTICLE2_DESCRIPTION8: '（4）个人信息保护政策',
            ARTICLE2_DESCRIPTION9: '・对于本公司的招聘，劳动，退休员工及其他劳动管理<br>\n' +
                '\t\t\t ・用于管理客户信息',
            ARTICLE3: '第2条个人信息的使用目的',
            ARTICLE3_DESCRIPTION1: '第三条同意提供个人信息',
            ARTICLE3_DESCRIPTION2: '在法律允许或您的同意下，我们将向第三方提供个人信息。但是，在以下情况下，公司可以在必要的范围内向第三方识别个人信息（在第1号和第2号的情况下，直接使用姓名和地址）信息不包括信息）。',
            ARTICLE3_DESCRIPTION3: '（1）必要时提供服务或改善质量',
            ARTICLE3_DESCRIPTION4: '（2）在必要时研究和开发新服务',
            ARTICLE3_DESCRIPTION6: '（3）将个人信息的处理委托给外国的第三方时',
            ARTICLE4: '第4条特别订购！',
            ARTICLE4_DESCRIPTION1: '以下规则适用于Order Go！',
            ARTICLE4_DESCRIPTION2: '（1）公开客户信息',
            ARTICLE4_DESCRIPTION3: '①您的Order Go！ID将显示在提供Order Go！的网站上，并向所有客户开放。此外，将通过在Order Go！中设置公共设置来公开客户发布的内容。',
            ARTICLE4_DESCRIPTION4: '②如果使用Order Go！功能将Order Go！与第三方站点链接，则在Order Go！上发布的全部或部分信息。会的。',
            ARTICLE4_DESCRIPTION5: '③即使因使用Order Go！披露信息而造成任何损坏或损失，除非有故意或重大过失，否则公司对任何损坏或损失概不负责。 。',
            ARTICLE4_DESCRIPTION6: '（2）服务终止和信息处理',
            ARTICLE4_DESCRIPTION7: '①如果客户完成了从Order Go！退出的程序，或者如果公司从Order Go！撤回了客户，则公司将立即停止在Order Go！上泄露客户信息。但是，即使在暂停过程之后，在暂停时已经与其他客户交换的某些消息或通过共享功能提供的信息也可能会继续泄露。 。',
            ARTICLE4_DESCRIPTION8: '（2）即使在前款中止披露之后，公司仍应遵守适用的适用法律和法规，并且在出于合法商业目的存档客户信息的最小必要范围内，公司在技术方面应具有合理的安全性。它可以通过安全存储方法连续保存。',
            ARTICLE5: '第六条披露，更正等程序',
            ARTICLE5_DESCRIPTION1: '公司应披露要披露的个人信息，通知使用目的，修改要披露的个人信息的使用等，等等。 “）”）将被接受。',
            ARTICLE5_DESCRIPTION2: 'https://www.google.com/intl/ja/policies/privacy/partners/',
            ARTICLE6: '第5条Google Analytics（分析）的使用',
            ARTICLE6_DESCRIPTION1: '公司应披露要披露的个人信息，通知使用目的，修改要披露的个人信息的使用等，等等。 “）”）将被接受。',
            ARTICLE6_DESCRIPTION2: '（1）要求公开的地方',
            ARTICLE6_DESCRIPTION3: '邮寄要求时，请将所需文件附在第7条指定的地址上并邮寄。',
            ARTICLE6_DESCRIPTION4: '（2）要提交的项目',
            ARTICLE6_DESCRIPTION5: '①个人信息使用/公开要求的通知',
            ARTICLE6_DESCRIPTION6: '②个人信息更正发票',
            ARTICLE6_DESCRIPTION7: '③暂停使用个人信息的发票',
            ARTICLE6_DESCRIPTION8: '④身份证明文件（驾驶证，护照等）',
            ARTICLE6_DESCRIPTION9: '⑤对于法定代表人，除上述④以外，还包含确认您具有法定代表人权利的文件',
            ARTICLE6_DESCRIPTION10: '（3）费用',
            ARTICLE6_DESCRIPTION11: '请注意，对于每次使用披露的要求和通知，将收取1000日元的费用。另外，通过邮件请求时，将通过转账收取费用。有关要求披露的具体程序等，请联系第8条中的联系点。',
            ARTICLE7: '第七条关于个人信息处理的咨询和投诉',
            ARTICLE7_DESCRIPTION11: '如果您对我们的个人信息的处理有任何疑问或投诉，请联系以下联系人。 。',
            CONTACT: '[有关个人信息的查询] <br>\n' +
                '\t\t\t〒???-???? <br>\n' +
                '\t\t\t？<br>\n' +
                '\t\t\t？<br>\n' +
                '\t\t\tSTUDIO55，Inc. <br>\n' +
                '\t\t\t营业时间/？：？〜？：？'
        },
        TERMS_AND_CONDITIONS: {
            TITLE: '使用条款',
            OVERVIEW_DESCRIPTION1: '1. STUDIO55，Inc.（以下简称“我们的公司”）是“ Order Go！”服务（以下简称为“ Order Go！”），以及我们将来将要启动的其他服务。 （以下分别称为“每项服务”）和普通服务的服务条款（以下简称“本协议”）。',
            OVERVIEW_DESCRIPTION2: '2.使用每项服务时，仅适用于每项服务的服务条款，在这种情况下，应遵循公司单独确定的每项服务的服务条款。',
            OVERVIEW_DESCRIPTION3: '通用服务条款',
            CHAPTER1: '第一章总则',
            ARTICLE1: '第一条本协议的范围和变更',
            ARTICLE1_DESCRIPTION1: '1.这些条款和条件适用于公司运营的网站所共有的服务（以下简称“服务”）。',
            ARTICLE1_DESCRIPTION2: '2.本协议应适用于所有使用此服务的用户（第3条中定义）。但是，对于本公司除此服务以外的其他每项服务，如果有仅在每种服务的服务条款中定义的规定，或者这些条款与相关项目中每项服务的服务条款之间存在重复规定仅适用于每项服务的服务条款。',
            ARTICLE1_DESCRIPTION3: '3.公司应在未经用户事先同意的情况下，以公司认为适当的方式通知用户，例如在网站上发布或发送电子邮件。可以进行一些更改。',
            ARTICLE1_DESCRIPTION4: '4.如果本协议的全部或部分被更改，则修订后的协议将应用于该服务的使用，并且用户应仅遵守修订后的协议。',
            ARTICLE1_DESCRIPTION5: '',
            ARTICLE2: '第二条服务的使用',
            ARTICLE2_DESCRIPTION1: '用户应根据公司另行确定的法律，法规，通知，本协议，个人信息保护政策，帮助等使用此服务。',
            CHAPTER2: '第2章用户',
            ARTICLE3: '第三条用户',
            ARTICLE3_DESCRIPTION1: '在本协议中，“用户”是指我公司在理解并同意本协议的所有内容后提供的内容，条款，文本，设计，徽标，视频，程序，思想，信息等（以下简称“本”）。集体指搜索，浏览或使用（内容在条款中定义）的人员（包括成员（在共同服务使用条款的第4条中定义））。',
            CHAPTER3: '第三章会员资格',
            ARTICLE4: '第四条会员',
            ARTICLE4_DESCRIPTION1: '在本协议中，“成员”一词是指在批准并批准本协议的所有内容之后，您根据我们规定的程序申请了成员资格注册，并且是在没有注册为成员的情况下批准了该成员的人员，对于那些已输入公司单独指定的每次购买的必要项目并获得公司批准的人员，这是一个统称。',
            ARTICLE5: '第五条会员注册',
            ARTICLE5_DESCRIPTION1: '1.如果您希望注册为会员，请遵循公司在“服务的会员注册”页面上单独指定的方法，以及公司的名称或公司名称，电话号码，电子邮件地址，密码或产品或服务）），应在设置并输入地址，姓名，电话号码和公司名称后提出会员注册申请。',
            ARTICLE5_DESCRIPTION2: '2.对于通过个人计算机，平板电脑终端或智能手机进行的会员注册，公司应根据第1款的要求按下会员注册按钮以批准会员注册。',
            ARTICLE5_DESCRIPTION3: '3.公司属于下列任何一项的，公司均不得批准注册。',
            ARTICLE5_DESCRIPTION4: '（1）如果您希望注册为会员，则必须遵守我们过去提供的任何服务的条款和条件（包括但不限于这些条款以及与站点上指定的每种服务相关的其他公司的条款）。明确会员由于违规等原因已被取消会员注册',
            ARTICLE5_DESCRIPTION5: '（2）希望过去注册为本公司提供的服务条款（包括本条款和与网站上指定的每项服务相关的其他公司条款）的成员。明确会员由于违规等原因已被取消会员注册',
            ARTICLE5_DESCRIPTION6: '（3）如果您希望注册为会员，则将向您收取过去的任何服务（包括但不限于与网站上指定的每种服务相关的其他公司的服务）。包括但不限于相同的付款，在下文中应适用。）向第三方支付与公司单独批准的付款方式有关的费用包括但不限于不履行等），或者发现长期接受不了商品，拒绝退货或换货或其他违约案例',
            ARTICLE5_DESCRIPTION7: '（4）当发现本协议第14条（禁止事项）的行为是过去进行的',
            ARTICLE5_DESCRIPTION8: '（5）在我们合理地确定批准其他注册不适合该服务的运营和管理时',
            ARTICLE5_DESCRIPTION9: '',
            ARTICLE6: '第6条变更登记内容',
            ARTICLE6_DESCRIPTION1: '1.如果在公司注册的任何或所有事项发生变更，会员应立即按照公司指定的方式更改其注册详细信息。',
            ARTICLE6_DESCRIPTION2: '2.对于因用户未适当注册更改而造成的任何损失，本公司概不负责。',
            ARTICLE7: '第七条暂停使用该服务并取消会员注册',
            ARTICLE7_DESCRIPTION1: '如果会员属于以下任何一项，公司可采取措施中止使用该服务，删除会员注册或其他公司认为适当的措施，恕不另行通知。会的',
            ARTICLE7_DESCRIPTION2: '（1）显然由于过去违反公司提供的任何服务条款而取消了会员注册',
            ARTICLE7_DESCRIPTION3: '（2）当发现注册内容包含虚假内容时',
            ARTICLE7_DESCRIPTION4: '（3）过去或现在，未对公司提供的任何服务进行费用等的支付（与公司另行批准的支付方式有关的费用的支付已向第三方执行）包括但不限于不存在的情况，或发现长期长期不可接受的收货，拒绝退货或换货或其他违约的情况',
            ARTICLE7_DESCRIPTION5: '（4）当发现本协议第14条（禁止事项）的行为是过去进行的',
            ARTICLE7_DESCRIPTION6: '（5）违反公司制定的任何其他规则的规定（包括但不限于这些条款）',
            ARTICLE8: '第8条退出程序',
            ARTICLE8_DESCRIPTION1: '会员可以按照公司规定的程序退出会员。由于合同月份是月初，因此如果您要从下个月退出，请在当月完成退出程序。 （示例）如果您从5月1日起不使用该服务，请在4月30日之前完成退出程序。此外，无论合同在合同期内被取消还是使用天数，均应全额支付公司指定的合同期限，即使已经支付了使用费，承包商将不获退款。',
            ARTICLE9: '第9条ID和密码管理',
            ARTICLE9_DESCRIPTION1: '1.会员应负责严格管理和存储会员注册时设置的电子邮件地址和密码。',
            ARTICLE9_DESCRIPTION2: '2.除非获得公司事先同意，否则会员不得将电子邮件地址和密码转让，购买，出售，转让，出借，披露或泄漏给第三方。',
            ARTICLE9_DESCRIPTION3: '3.会员如发现其电子邮件地址或密码被第三方非法使用，应立即与公司联系，并应遵守公司提供的任何指示。',
            ARTICLE9_DESCRIPTION4: '4.会员应对电子邮件地址或密码管理不善，使用中的错误或遗漏，第三方未经授权使用等所造成的损失负责，本公司概不负责。 。',
            ARTICLE10: '第十条个人信息的使用',
            ARTICLE10_DESCRIPTION1: '我们已了解到的与使用此服务有关的会员的个人信息，将根据公司另行制定的“个人信息保护政策”进行处理。',
            CHAPTER4: '第四章服务的使用',
            ARTICLE11: '第十一条提供的服务',
            ARTICLE11_DESCRIPTION1: '作为此服务的一部分，我们提供以下服务。',
            ARTICLE11_DESCRIPTION2: '（1）会员使用“我的页面”（第12条中定义）',
            ARTICLE11_DESCRIPTION3: '（2）跨服务搜索',
            ARTICLE11_DESCRIPTION4: '（3）查看各服务信息',
            ARTICLE11_DESCRIPTION5: '（4）查看各服务的链接',
            ARTICLE12: '第十二条控制台的使用',
            ARTICLE12_DESCRIPTION1: '会员可以使用我们指定的控制台。控制台可以设置，注册和注册会员已设置或购买的设备，角色，背景，AI服务，配置文件和见解，作为已登录该服务的会员的购买，注册，设置和浏览功能。提供浏览功能。',
            ARTICLE13: '第十三条免责声明',
            ARTICLE13_DESCRIPTION1: '1.如果您提供从此服务到另一个网站或资源的链接，或从第三方网站或资源到该服务的链接，则公司将使用该链接的内容，用法和结果。不承担任何责任（包括但不限于合法性，有效性，准确性，确定性，安全性，最新性和完整性）。如果公司合理确定链接的网站或资源的内容对服务的管理和运营是非法的或不适当的，则相关假定可以删除链接目标。',
            ARTICLE13_DESCRIPTION2: '2.广告（包括但不限于抽奖广告）或与广告客户进行促销服务的交易（包括参加抽奖等促销活动，但不限于此）在这种情况下，用户应自行决定并承担与广告客户进行交易的责任，本公司对此不承担任何责任。本公司不保证与交易相关的任何内容或条件，例如货款支付，确定合同条件，担保，担保责任，许可证存在等，并且我们已张贴在此服务中会员对通过广告或促销进行的交易造成的任何损失不承担任何责任。',
            ARTICLE13_DESCRIPTION3: '3.即使在以下情况下暂时暂停，暂停或更改了本服务，公司也不对会员直接或间接遭受的任何损害，损失，劣势等负责：不应承担。',
            ARTICLE13_DESCRIPTION4: '（1）在发生火灾，地震，洪水，雷击，大雪等自然灾害时',
            ARTICLE13_DESCRIPTION5: '（2）发生战争，内战，恐怖主义，暴动或暴动等社会动乱时',
            ARTICLE13_DESCRIPTION6: '（3）当我们无法从与我们签有合同的电话公司，运输公司或提供商那里获得适当的服务时',
            ARTICLE13_DESCRIPTION7: '（4）当由于某种原因我公司无法在技术上处理',
            ARTICLE13_DESCRIPTION8: '4.公司应按照会员注册的内容处理事务，以履行其义务并获得豁免。',
            ARTICLE13_DESCRIPTION9: '5.如果会员使用此服务对其他用户或第三方造成任何损害，则会员将自行承担责任解决并承担费用。我们不会给您任何损害，损失或不利影响。',
            ARTICLE14: '第十四条禁止事项',
            ARTICLE14_DESCRIPTION1: '用户不得执行以下任何行为。万一违反此规定给公司或第三方造成损害的，由用户承担所有损害的责任。',
            ARTICLE14_DESCRIPTION2: '（1）其他用户，除其他用户外的第三方，对公司造成不便，不利或损害的行为，或可能导致他们的行为',
            ARTICLE14_DESCRIPTION3: '（2）侵犯其他用户，除其他用户之外的第三方，知识产权，例如版权，肖像权，人格权，隐私权，宣传权或其他权利的行为可能导致的行为',
            ARTICLE14_DESCRIPTION4: '（3）将这项服务用于商业目的的行为（不包括公司事先批准的行为）',
            ARTICLE14_DESCRIPTION5: '（4）违反公共秩序和道德的行为或其他违反或可能违反法律法规的行为',
            ARTICLE14_DESCRIPTION6: '（5）注册包含虚假或误导性信息的信息的行为',
            ARTICLE14_DESCRIPTION7: '（6）用户对通过本服务获得的内容的使用超出了私人使用范围（但是，不包括公司事先批准的内容）',
            ARTICLE14_DESCRIPTION8: '（7）通过其他用户或除其他用户外的第三方复制，出售，发布，分发，发布通过本服务获得的内容，以及类似行为（但是，公司应（已批准的除外）。',
            ARTICLE14_DESCRIPTION9: '（8）收集，存储或保留其他用户的个人信息',
            ARTICLE14_DESCRIPTION10: '（9）将上载旨在干扰，破坏或限制计算机软件，硬件和通信设备功能的内容（例如计算机病毒，计算机代码，文件，程序等）上传到服务，或通过电子邮件上传通过发送',
            ARTICLE14_DESCRIPTION11: '（10）同一会员注册多个会员的行为（包括通过任何PC，移动电话或智能手机注册多个注册的行为，但公司事先批准的除外）。',
            ARTICLE14_DESCRIPTION12: '（11）退货过多',
            ARTICLE14_DESCRIPTION13: '（12）我们合理判断为不适当的其他行为，例如信用损失或损失',
            ARTICLE15: '第十五条知识产权',
            ARTICLE15_DESCRIPTION1: '1.通过此服务提供的内容的所有知识产权应归公司所有。',
            ARTICLE15_DESCRIPTION2: '2.如果发现出于任何目的而发现本国或外国版权法或其他法律禁止的任何行为，例如未经授权的复制，未经授权的转载或其他未经授权的二次使用我们的内容公司应立即采取法律行动。',
            ARTICLE15_DESCRIPTION3: '3.如果与第三方发生任何违反本条规定的纠纷，会员应自负责任和费用解决纠纷，并给公司造成任何损害，损失或不利。不得给予。',
            CHAPTER5: '第五章服务运营',
            ARTICLE16: '第十六条信息管理',
            ARTICLE16_DESCRIPTION1: '1.公司有权自行决定自由使用用户在公司及其附属网站上与服务相关的全部或部分内容。在使用内容时，我们不需要向张贴者付款。',
            ARTICLE16_DESCRIPTION2: '2.本公司收集与用户访问历史有关的以下信息，以调查用户的访问历史和使用状态或改善对用户的服务。公司发行的Cookies用于有效分发广告等目的，不用于个人信息收集或其他目的。',
            ARTICLE16_DESCRIPTION3: '（1）用户访问此服务的服务器时与IP地址或移动设备标识号有关的信息',
            ARTICLE16_DESCRIPTION4: '（2）Cookie技术（一种通过Web浏览器将数据临时写入用户计算机，并记录并保存用户上次访问该站点的日期和时间，对该站点的访问次数等的技术） ）通过获取的用户访问信息',
            ARTICLE16_DESCRIPTION5: '3.用户事先确认，如果用户进行设置以拒绝Web浏览器上的cookie，则可能会限制该服务的使用。',
            ARTICLE17: '第十七条本服务的维护',
            ARTICLE17_DESCRIPTION1: '为了使该服务的运行状态保持良好状态，公司将暂时停止全部或部分提供此服务，而无需事先通知用户以下任何一项：或者可以将其取消。',
            ARTICLE17_DESCRIPTION2: '（1）在定期维护和紧急维护提供此服务的计算机系统（以下简称“系统”）的情况下',
            ARTICLE17_DESCRIPTION3: '（2）当由于火灾，地震，洪水，雷击，大雪等自然灾害而使系统操作变得困难时。',
            ARTICLE17_DESCRIPTION4: '（3）当系统由于战争，内战，恐怖主义，暴动和噪音等社会动荡而变得难以运行时',
            ARTICLE17_DESCRIPTION5: '（4）当由于系统故障，来自第三方的未授权访问，计算机病毒感染等导致系统操作变得困难时。',
            ARTICLE17_DESCRIPTION6: '（5）当政治或司法机构基于合理理由提出要求时',
            ARTICLE17_DESCRIPTION7: '（6）当公司确定必须不可避免地停止或取消系统时',
            ARTICLE18: '第十八条其他',
            ARTICLE18_DESCRIPTION1: '1.如果出现无法通过使用这些条款或我们对使用此服务的指导和回应解决的问题，公司和用户应真诚讨论并解决。',
            ARTICLE18_DESCRIPTION2: '2.如果需要使用此服务的诉讼，名古屋地方法院应为一审专属协议法院。',
            ARTICLE18_DESCRIPTION3: '附录：本协议自2018年11月21日起适用于所有用户。',
            ORDERGO_TITLE: '订购Go！服务条款',
            ORDERGO_CHAPTER1: '第一章总则',
            ORDERGO_ARTICLE1: '第一条本协议的范围和变更',
            ORDERGO_ARTICLE1_DESCRIPTION1: '1.本协议（以下简称“条款”）是指公司及其成员使用与公司运营的“ Order Go！”网站相关的服务（以下简称“服务”）的情况。 （如第3条所定义）。但是，对于公司提供的除此服务以外的其他服务，仅适用与每个服务相关的使用条款。',
            ORDERGO_ARTICLE1_DESCRIPTION2: '2.公司应在未事先征得会员事先同意的情况下，通过以公司认为适当的方式通知或通知会员，例如在网站或电子邮件上发布，来通知全部或其中一份使用条款。零件可以更改。',
            ORDERGO_ARTICLE1_DESCRIPTION3: '3.如果更改本协议的全部或部分，则仅新协议将适用于此服务的使用，并且会员应仅遵循新协议。',
            ORDERGO_ARTICLE2: '第二条服务的使用',
            ORDERGO_ARTICLE2_DESCRIPTION1: '1.会员应根据法律，法规，规章，通知，常用服务使用条款，这些条款，个人信息保护政策，帮助等使用本公司单独确定的服务。',
            ORDERGO_ARTICLE2_DESCRIPTION2: '2.未经合格法律代表的事先同意，未成年人不能使用此服务。',
            ORDERGO_ARTICLE3: '第三条提供的服务',
            ORDERGO_ARTICLE3_DESCRIPTION1: '用户可以在此服务中执行以下操作。',
            ORDERGO_ARTICLE3_DESCRIPTION2: '（1）会员可以根据我们规定的方法设置角色，背景，AI服务等，以使用本服务从本公司购买产品等。',
            ORDERGO_CHAPTER2: '第二章会员',
            ORDERGO_ARTICLE4: '第四条会员',
            ORDERGO_ARTICLE4_DESCRIPTION1: '本协议中的“会员”应遵守公司分别定义的“通用服务使用条款”和“第4条会员资格”的规定。',
            ORDERGO_ARTICLE5: '第五条会员注册',
            ORDERGO_ARTICLE5_DESCRIPTION1: '1.注册为会员时，必须先输入并设置<条款5会员注册>中定义的会员注册所需项目，然后才能申请注册。',
            ORDERGO_ARTICLE5_DESCRIPTION2: '2.未经合格法律代表的事先同意，未成年人不能申请会员注册。',
            ORDERGO_ARTICLE5_DESCRIPTION3: '3.如果注册属于以下任何一项，则公司不得批准注册。',
            ORDERGO_ARTICLE5_DESCRIPTION4: '（1）任何希望注册为会员的人都违反了公司过去提供的任何服务的条款（包括但不限于这些条款以及与站点上指定的每种服务相关的其他公司的条款）。如果很明显由于以下原因取消了会员注册',
            ORDERGO_ARTICLE5_DESCRIPTION5: '（2）会员注册的申请者的申请书的内容清楚地包含虚假的事项时',
            ORDERGO_ARTICLE5_DESCRIPTION6: '（3）如果您过去没有支付任何服务费用（包括但不限于与网站上指定的每种服务相关的其他公司的服务）（包括但不限于与公司单独批准的付款方式相关的第三方费用或无正当理由的长期产品付款当明确表示无法接收服务（以下统称为“产品等”），拒绝退货或交换或其他违约',
            ORDERGO_ARTICLE5_DESCRIPTION7: '（4）过去发现执行了“通用服务使用条款”“第14条禁止物品”',
            ORDERGO_ARTICLE5_DESCRIPTION8: '（5）在我们合理地确定批准其他注册不适合该服务的运营和管理时',
            ORDERGO_ARTICLE6: '第6条变更登记内容',
            ORDERGO_ARTICLE6_DESCRIPTION1: '1.当在公司注册的姓名，地址，电话号码或其他事项全部或部分更改时，会员应立即按照公司指定的方式更改注册详细信息。 。',
            ORDERGO_ARTICLE6_DESCRIPTION2: '2.对于因会员未适当注册而造成的任何损失，本公司概不负责。',
            ORDERGO_ARTICLE7: '第七条暂停使用该服务并取消会员注册',
            ORDERGO_ARTICLE7_DESCRIPTION1: '如果会员属于以下任何一项，公司可以采取公司认为适当的任何措施，例如暂停使用该服务，取消会员注册等，恕不另行通知。和',
            ORDERGO_ARTICLE7_DESCRIPTION2: '（1）违反与我们公司过去提供的任何服务有关的条款（包括但不限于这些条款以及与站点上指定的每种服务有关的其他公司的条款）事实证明该成员已被解雇',
            ORDERGO_ARTICLE7_DESCRIPTION3: '（2）清楚地表明注册内容中包含虚假内容',
            ORDERGO_ARTICLE7_DESCRIPTION4: '（3）过去或现在，已经对公司提供的任何服务（包括但不限于与站点上指定的每种服务相关的其他公司的服务）进行了收费等。如果不是（包括但不限于与公司单独批准的付款方式有关的向第三方支付的费用等）或长时间无正当理由当发现收货不合格，拒绝退货或换货或其他违约',
            ORDERGO_ARTICLE7_DESCRIPTION5: '（4）<公共服务使用条款>证明已经执行了“第十四条禁止物品”的行为',
            ORDERGO_ARTICLE7_DESCRIPTION6: '（5）如果违反公司制定的任何其他条款和条件（包括但不限于这些条款和与网站上指定的每种服务相关的其他公司的条款）',
            ORDERGO_ARTICLE8: '第8条退出程序',
            ORDERGO_ARTICLE8_DESCRIPTION1: '如果您希望退出会员制，则应适用<通用服务使用条款>中单独定义的<第8条辞职程序>的规定。',
            ORDERGO_CHAPTER3: '第三章产品采购',
            ORDERGO_ARTICLE9: '第9条货物购买',
            ORDERGO_ARTICLE9_DESCRIPTION1: '1.如果会员希望购买产品等，则他/她应按照公司另行规定的方法申请购买或使用产品。',
            ORDERGO_ARTICLE9_DESCRIPTION2: '2.确认会员根据上一节中的申请输入/注册的订单内容后，单击按钮下订单，然后当确认订单内容的电子邮件到达我们公司的会员时会员与公司之间应订立产品的销售合同等。',
            ORDERGO_ARTICLE9_DESCRIPTION3: '3.尽管有前款的规定，如果在使用此服务方面存在任何欺诈或不当行为，公司将能够取消，取消或以其他方式采取适当的销售合同措施。',
            ORDERGO_ARTICLE10: '第10条支付方式',
            ORDERGO_ARTICLE10_DESCRIPTION1: '1.货物等的付款额是货物的购买价格的总和，包括消费税和与此有关的手续费。',
            ORDERGO_ARTICLE10_DESCRIPTION2: '2.通过此服务购买的商品的付款仅限于以会员名义使用信用卡付款或公司另行批准的付款方式。',
            ORDERGO_ARTICLE10_DESCRIPTION3: '3.使用信用卡付款时，会员应遵守与信用卡公司签订的单独合同。此外，会员与信用卡公司之间在使用信用卡方面发生任何争议时，会员和信用卡公司应负责任地解决。',
            ORDERGO_ARTICLE11: '第十一条产品的退回，交换，撤回和取消',
            ORDERGO_ARTICLE11_DESCRIPTION1: '1.关于撤回和取消订单，除非有我们的责任，否则不能撤回或取消产品订单。',
            ORDERGO_ARTICLE11_DESCRIPTION2: '2.仅在以下情况下才接受退货。',
            ORDERGO_ARTICLE11_DESCRIPTION3: '（1）当发现该产品是假冒或盗版产品时',
            ORDERGO_ARTICLE11_DESCRIPTION4: '（2）产品有瑕疵时',
            ORDERGO_ARTICLE12: '第十二条免责',
            ORDERGO_ARTICLE12_DESCRIPTION1: '1.公司对产品的质量，材料，功能，性能，程序，与其他产品的兼容性以及其他缺陷，或由这些产品引起的任何损坏或损失等负责。在不利条件等情况下，除前条规定的情况外，不承担任何保证或负担。',
            ORDERGO_ARTICLE12_DESCRIPTION2: '2.公司对会员在所有Order Go！服务上以及首页和销售页上使用Twitter和其他SNS服务发布的产品和设置发表评论。但是，除非有意或重大过失，否则我们对购买产品的会员造成的任何损害不承担任何责任。',
            ORDERGO_ARTICLE12_DESCRIPTION3: '附录：本协议自2018年11月29日起适用于所有成员。',
        },
        LATEST_CHANGES: {
            ADD_PROJECT: '{{projectName}} - {{fullname}}添加了项目{{subject}}',
            UPDATE_PROJECT: '{{projectName}} - {{fullname}}更新了项目{{subject}}',
            UPDATE_PROJECT_BY_CLIENT: '{{projectName}} - {{fullname}}更新了项目{{subject}}',
            DELETE_PROJECT: '{{projectName}} - {{fullname}}删除了项目{{subject}}',
            ADD_CONVERSATION: '{{projectName}} - {{fullname}}添加了聊天群组{{subject}}',
            UPDATE_CONVERSATION: '{{projectName}} - {{fullname}}更新了聊天群组{{subject}}的对话',
            DELETE_CONVERSATION: '{{projectName}} - {{fullname}}删除了聊天群组{{subject}}',
            ADD_MESSAGE: '{{projectName}} - {{fullname}} has added the {{subject}} message',
            UPDATE_MESSAGE: '{{projectName}} - {{fullname}} has modified the {{subject}} message',
            DELETE_MESSAGE: '{{projectName}} - {{fullname}} has deleted the {{subject}} message',
            UNREAD: '未读'
        },
        GANTT_CHART: {
            TITLE: '日程表',
            ADD_TASK_BUTTON: '添加任务',
            UPDATE_TASK: '更新任务',
            ADD_TASK: '添加任务',
            SUBJECT: '任务名称',
            SUBJECT_ERROR: '任务名称错误',
            FROM_DATE: '开始日期',
            FROM_DATE_ERROR: '开始日期错误',
            TO_DATE: '截止日期',
            TO_DATE_ERROR: '截止日期错误',
            COLOR: '颜色',
            RED_COLOR: '红色',
            BLUE_COLOR: '蓝色',
            PRIORITY: '优先',
            SEND_SCHEDULE_BUTTON: 'send schedule',
            SEND_SCHEDULE_BUTTON_MOBILE: 'send',
            ADD_TASK_BUTTON_MOBILE: 'task',
        },
        LIBRARY: {
            TITLE : 'Library',
            FILE_NAME : 'File Name',
            ADD: 'Add',
            EDIT: 'EDIT',
            DELETE: '删掉',
            TAGS : 'Tags',
            ADD_NEW_TAG: 'Add New Tag',
            SEARCH_BY_TAGS: 'Search by Tag',
            SEARCH_BY_MATERIAL: 'Search by Material',
            SEARCH_BY_COLOR: 'Search by Color',
            UPLOAD_FILE_FROM_OUTSIDE: 'Upload File',
            SELECT_TAGS: 'Select Tags',
            SELECT_COLORS: 'Select Colors',
            LIST_OF_MATERIALS: 'List of Materials'
        },
        PUSH_NOTIFICATION: {
            PROJECT_MODIFIED_TITLE: '项目修改',
            PROJECT_MODIFIED_BODY: '{{fullname}}已修改{{name}}项目。',
            CONVERSATION_MODIFIED_TITLE: '聊天组已修改',
            CONVERSATION_MODIFIED_BODY: '{{fullname}}已修改{{name}}聊天组。',
            MESSAGE_ADDED_TITLE: '新消息',
            MESSAGE_ADDED_BODY: '{{fullname}}已向{{name}}发送了一条新消息',
            DIRECT_MESSAGE_ADDED_BODY: '從{{fullname}}收到新消息',
            NOTIFICATION_TITLE: '通知',
            NOTIFICATION_TEXT: '通知正在等待您'
        },
        FILE_ANNOTATIONS: {
            RECTANGLE_TOOL: 'Rectangle tool',
            CIRCLE_TOOL: 'Circle tool',
            ARROW_TOOL: 'Arrow tool',
            POLYGON_TOOL: 'Polygon tool',
            PAINT_TOOL: 'Paint tool',
            ANNOTATION_TOOL: 'Annotation tool',
            SAVE_AND_SEND: 'Save and send',
            SAVE_AND_CLOSE: 'Save and close',
            CLOSE_WITHOUT_SAVE: 'Close without save',
            ANGLE: "Angle",
            SAVE: "Save",
            ADD: "Add",
            RESTORE: 'Restore',
            ADD_COMMENT: "Add comment",
            PERSPECTIVE_CORRECTION: "Perspective correction",
            DOWNLOAD_ANNOTATED_IMAGE: "Download annotated image",
            DOWNLOAD_ORIGINAL_IMAGE: "Download original image",
            DELETE: 'Delete',
            UNDO: 'Undo',
            REDO: 'Redo',
            RESIZE: 'Resize',
            DOWNLOAD: 'Download',
            DISPLAY_HORIZONTAL: 'Display horizontal',
            DISPLAY_VERTICAL: 'Display vertical',
            DESCRIPTION: '<p>You can check back directly from here.</p><p>*Number the figure and add a comment.</p><p>※You can also enter shapes and arrows.</p>',
        }
    }
};
